import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "step" }
const _hoisted_2 = {
  key: 0,
  class: "subheader"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 2,
  class: "postheader"
}
const _hoisted_5 = {
  key: 3,
  class: "hint"
}

import { ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'Step',
  props: {
  id: {
    type: String,
    default: "",
    required: false,
  },
},
  setup(__props, { expose: __expose }) {

const props = __props;

const stepContentRef = ref<HTMLDivElement | null>(null);
const contentRef = ref<HTMLDivElement | null>(null);
const stepHeaderRef = ref<HTMLDivElement | null>(null);
const stepButtonsRef = ref<HTMLDivElement | null>(null);

__expose({
  props,
  contentRef,
  stepContentRef,
  stepHeaderRef,
  stepButtonsRef,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.$slots.subheader || _ctx.$slots.header)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "step-header",
          ref_key: "stepHeaderRef",
          ref: stepHeaderRef
        }, [
          (_ctx.$slots.subheader)
            ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
                _renderSlot(_ctx.$slots, "subheader")
              ]))
            : _createCommentVNode("", true),
          (_ctx.$slots.header)
            ? (_openBlock(), _createElementBlock("h1", _hoisted_3, [
                _renderSlot(_ctx.$slots, "header")
              ]))
            : _createCommentVNode("", true),
          (_ctx.$slots.postheader)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
                _renderSlot(_ctx.$slots, "postheader")
              ]))
            : _createCommentVNode("", true),
          (_ctx.$slots.hint)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
                _renderSlot(_ctx.$slots, "hint")
              ]))
            : _createCommentVNode("", true)
        ], 512))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "step-content",
      ref_key: "stepContentRef",
      ref: stepContentRef
    }, [
      _createElementVNode("div", _mergeProps({ class: "content" }, _ctx.$attrs, {
        ref_key: "contentRef",
        ref: contentRef
      }), [
        _renderSlot(_ctx.$slots, "default")
      ], 16)
    ], 512),
    _createElementVNode("div", {
      class: "step-btns",
      ref_key: "stepButtonsRef",
      ref: stepButtonsRef
    }, [
      _renderSlot(_ctx.$slots, "actions")
    ], 512)
  ]))
}
}

})